import { BrowserRouter as Router, Routes, Route } from "react-router";
import ConsentBanner from "./components/common/ConsentBanner";
import ProtectedRoute from './context/ProtectedRoute';
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import ConfirmationPage from "./pages/AuthPages/ConfirmationPage";
import ResetPasswordPage from "./pages/AuthPages/ResetPasswordPage";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import RestaurantList from "./pages/Restaurants/RestaurantList";
import RestaurantNew from "./pages/Restaurants/RestaurantNew";
import RestaurantEdit from "./pages/Restaurants/RestaurantEdit";
import MenuList from "./pages/Menus/MenuList";
import MenuNew from "./pages/Menus/MenuNew";
import MenuEdit from "./pages/Menus/MenuEdit";
import MenuItemList from "./pages/MenuItems/MenuItemList";
import MenuItemNew from "./pages/MenuItems/MenuItemNew";
import UpdatePasswordWithTokenPage from "./pages/AuthPages/UpdatePasswordWithTokenPage";
import QrCodePage from "./pages/QrCodePages/QrCodePage";
import LandingPage from "./pages/LandingPage/LandingPage";
import HomePage from "./pages/Dashboard/HomePage";

const App = () => {
  return (
    <>
      <ConsentBanner />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>

              {/* Others Page */}
              <Route path="/profile" element={<UserProfiles />} />
              
              {/* Real routes */}
              <Route path="/dashboard" element={<HomePage />} />

              <Route path="/restaurants" element={<RestaurantList />} />
              <Route path="/restaurants/new" element={<RestaurantNew />} />
              <Route path="/restaurants/:id/edit" element={<RestaurantEdit />} />

              <Route path="/restaurants/:id/menus" element={<MenuList />} />
              <Route path="/restaurants/:id/menus/new" element={<MenuNew />} />
              <Route path="/menus/:id/edit" element={<MenuEdit />} />

              <Route path="/menus/:id/menu_items" element={<MenuItemList />} />
              <Route path="/menus/:id/menu_items/new" element={<MenuItemNew />} />
              
            </Route>
          </Route>
          {/* Auth Layout */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/email_confirmation" element={<ConfirmationPage />} />
          <Route path="/reset_password" element={<ResetPasswordPage />} />
          <Route path="/update_password_with_token" element={<UpdatePasswordWithTokenPage />} />

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />

          {/* Public Routers */}
          <Route path="/qr/:public_id" element={<QrCodePage />} />
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
